import { Button } from "@clockwise/design-system";
import React, { ComponentProps } from "react";

export type ExternalLinkButtonProps = ComponentProps<typeof Button> & {
  url: string;
  onLinkOpen?: () => void;
  "cw-id"?: string;
};

export const ExternalLinkButton = ({
  url,
  onLinkOpen,
  ...buttonProps
}: ExternalLinkButtonProps) => {
  const handleClick = () => {
    if (!url) {
      return;
    }

    window.open(url, "_blank");
    onLinkOpen?.();
  };

  return <Button onClick={handleClick} cw-id="external-link-button" {...buttonProps} />;
};
